<mat-card class="pageWrapper">
    <mat-card-content>
        <mat-form-field class="fullWidth" appearance="outline">
            <mat-label>Filter</mat-label>
            <input matInput (keyup)="applyFilter($event)" #input>
        </mat-form-field>
    </mat-card-content>
    <div class="mat-elevation-z8 responsive-table-cont">
        <div class="responsive-table">
            <table mat-table [dataSource]="dataSource" matSort>
                <ng-container matColumnDef="dateTime">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Date
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.dateTime}} </td>
                </ng-container>
                <ng-container matColumnDef="logName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Action
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.logName}} </td>
                </ng-container>
                <ng-container matColumnDef="objectName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> File/Folder Created
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.objectName}} </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
        <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
        </mat-paginator>
    </div>
</mat-card>